import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { caureInterview, caureHeroPhoto } from '../data/caureInterview';

const CaureTeaser = () => {
  const { language } = useLanguage();
  const c = caureInterview[language] || caureInterview.fr;

  return (
    <section
      id="interview-vincent-caure"
      data-testid="caure-teaser-section"
      className="bg-[#1a1c1b] pb-20 md:pb-28"
    >
      <div className="max-w-[87.5rem] mx-auto px-6 md:px-10">
        <div className="relative border border-[#3f4816]/70 bg-[#302f2c]/60 rounded-sm overflow-hidden">
          <div className="absolute top-0 left-0 right-0 h-1 bg-[#d9fb06]" />

          <div className="grid grid-cols-1 lg:grid-cols-12">
            {/* Photo */}
            <div className="lg:col-span-6 lg:order-2 relative">
              <div className="relative overflow-hidden aspect-[3/2] lg:aspect-auto lg:h-full lg:min-h-[26rem] bg-[#0f1110]">
                <img
                  src={caureHeroPhoto.src}
                  alt={caureHeroPhoto.alt[language] || caureHeroPhoto.alt.fr}
                  loading="lazy"
                  className="w-full h-full object-cover object-[center_30%]"
                  data-testid="caure-teaser-photo"
                />
                <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-[#302f2c]/70 lg:from-[#302f2c] via-transparent to-transparent" />
              </div>
              <span
                data-testid="caure-teaser-badge"
                className="absolute top-5 right-5 bg-[#d9fb06] text-[#1a1c1b] text-[0.65rem] font-black tracking-[0.2em] uppercase px-3 py-1.5 rounded-full"
              >
                {c.teaser.badge}
              </span>
            </div>

            {/* Text */}
            <div className="lg:col-span-6 lg:order-1 p-8 md:p-12 lg:p-14 flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-5">
                <div className="h-px w-10 bg-[#d9fb06]" />
                <span className="text-[#d9fb06] text-xs tracking-[0.25em] uppercase font-semibold">
                  {c.teaser.eyebrow}
                </span>
              </div>

              <h2
                data-testid="caure-teaser-title"
                className="font-black text-white text-2xl sm:text-3xl md:text-4xl lg:text-[2.75rem] leading-[1.05] mb-6"
              >
                {c.teaser.title}
              </h2>

              <p className="text-[#c9c7c0] text-base md:text-lg leading-relaxed mb-8 max-w-xl">
                {c.teaser.summary}
              </p>

              <div className="flex flex-wrap items-center gap-5">
                <Link
                  to="/interview-vincent-caure"
                  data-testid="caure-teaser-cta"
                  className="group inline-flex items-center gap-3 bg-[#d9fb06] text-[#1a1c1b] px-7 py-4 rounded-full font-bold text-sm uppercase tracking-wider hover:bg-white transition-all duration-300"
                >
                  {c.teaser.cta}
                  <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                </Link>
                <span className="text-[#888680] text-xs uppercase tracking-[0.2em]">{c.hero.dateline}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaureTeaser;
